export default __webpack_public_path__ + "static/media/img-slider-token-6.7a33c458.png";